var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 36.4303V13.9052L13.1311 0.77411L26.2622 13.9052V36.4303H0ZM2.62622 33.8041H11.1089V27.7428H15.1507V33.8041H23.6334V14.961L13.1285 4.45607L2.6236 14.961L2.62622 33.8041ZM11.1089 20.069V16.0246H15.1507V20.069H11.1089ZM30.5036 36.4829V12.1404L19.1347 0.771484H22.8665L33.1298 11.0374V36.4802L30.5036 36.4829ZM37.3738 36.4829V9.27519L28.8727 0.77411H32.6545L40 8.16956V36.4802L37.3738 36.4829Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector-2.8d49c66a208fde58d6e32a60dbe3d377.svg";
export { ForwardRef as ReactComponent };